

export enum WssEntity {
	clients = 'clients',
	invoices = 'invoices',
	estimates = 'estimates',
	event = 'event',
	items = 'items',
	taxes = 'taxes',
	categories = 'categories',
	expenses = 'expenses',

	team_users = 'team_users',
	account_roles = 'account_roles',
	account_role_permissions = 'account_role_permissions'
}

export type WssPayLoad = {
	entity: WssEntity
	id: string
	broadcast_time: number
}